// extracted by mini-css-extract-plugin
export default {"iconContainer":"Logo_iconContainer__MUOD-","defaultIcon":"Logo_defaultIcon__URztw","primary":"Logo_primary__zL8H0","neshIcon":"Logo_neshIcon__+nCii"};